/**
 * [Person 个人票务]
 * @type {Array}
 */
export default [{
  path: 'person',
  name: 'person',
  redirect: 'person/choose_date',
  component: resolve => require(['@/views/person/index'], resolve),
  meta: {
    title: '个人预约',
    auth: false
  },
  // children: [{
  //     path: 'choose_date',
  //     name: 'choose_date',
  //     component: resolve => require(['@/views/person/chooseDate'], resolve),
  //     meta: {
  //       title: '选择参观日期',
  //       auth: false
  //     }
  //   },
  //   {
  //     path: 'fill_info',
  //     name: 'fill_info',
  //     component: resolve => require(['@/views/person/fillInInfo'], resolve),
  //     meta: {
  //       title: '填写预约信息',
  //       auth: true
  //     }
  //   },
  //   {
  //     path: 'confirm_info',
  //     name: 'confirm_info',
  //     component: resolve => require(['@/views/person/confirmInfo'], resolve),
  //     meta: {
  //       title: '确认预约信息',
  //       auth: true
  //     }
  //   },
  //   {
  //     path: 'success',
  //     name: 'success',
  //     component: resolve => require(['@/views/person/success'], resolve),
  //     meta: {
  //       title: '预约成功',
  //       auth: true
  //     }
  //   },
  //   // {
  //   //   path: 'order_list',
  //   //   name: 'order_list',
  //   //   component: resolve => require(['@/views/person/orderList'], resolve),
  //   //   meta: {
  //   //     title: '预约记录',
  //   //     auth: true
  //   //   }
  //   // },
  //   {
  //     path: 'order_detail',
  //     name: 'order_detail',
  //     component: resolve => require(['@/views/person/orderDetail'], resolve),
  //     meta: {
  //       title: '预约详情',
  //       auth: true
  //     }
  //   },
  // ]
}]



// WEBPACK FOOTER //
// ./src/router/modules/person.js